import { createActionConst } from '../../../../utils/action.utils';

const CONCLUSIONS_NAMESPACE = 'CONCLUSIONS';

export const STORE_CONCLUSIONS = createActionConst(CONCLUSIONS_NAMESPACE, 'STORE_CONCLUSIONS');
export const CLEAR_CONCLUSIONS = createActionConst(CONCLUSIONS_NAMESPACE, 'CLEAR_CONCLUSIONS');
export const SHOW_RECAP_VALIDATION_ERRORS = createActionConst(CONCLUSIONS_NAMESPACE, 'SHOW_RECAP_VALIDATION_ERRORS');

export const SETUP_CONCLUSIONS = createActionConst(CONCLUSIONS_NAMESPACE, 'SETUP_CONCLUSIONS');
export const SAVE_CONCLUSION = createActionConst(CONCLUSIONS_NAMESPACE, 'SAVE_CONCLUSION');
export const DELETE_CONCLUSION = createActionConst(CONCLUSIONS_NAMESPACE, 'DELETE_CONCLUSION');

export const SAVE_CONCLUSION_SOCKET = 'saveConclusion';
export const DELETE_CONCLUSION_SOCKET = 'deleteConclusion';
